import React from 'react';
import {
  Dialog,
  Typography,
  Box,
  Stack,
  BoxProps,
  useTheme,
  useMediaQuery,
  IconButton,
  Button,
  ButtonProps,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type TTrialStartModalProps = {
  open: boolean;
  onClose: () => void;
};

const background: BoxProps['sx'] = {
  background: `url(${process.env.PUBLIC_URL}/images/productValue/graphic.png), linear-gradient(103.87deg, #006C9C 7.37%, #002536 100%)`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  borderRadius: '15px',
  padding: '5px',
  position: 'relative',
  margin: '2px',
};

const buttonProps: ButtonProps = {
  disableElevation: true,
  color: 'inherit',
  variant: 'contained',
  sx: {
    padding: '12px 50px',
    fontSize: '16px',
    fontWeight: '600',
    borderRadius: '30px',
    backgroundColor: '#F8FAFC',
  },
};

const PremiumTrialStartModal: React.FC<TTrialStartModalProps> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const belowMd = useMediaQuery(theme.breakpoints.down('md'));

  const handleOnClick = () => {
    const url = window.location.pathname;
    window.history.replaceState(null, '', url);
    onClose();
  };

  return (
    <Dialog
      PaperProps={{
        sx: { borderRadius: '15px', maxWidth: '800px', position: 'relative' },
      }}
      open={open}
      onClose={onClose}
    >
      <Box sx={background}>
        <Stack margin="45px" alignItems="center" spacing={4}>
          <Stack
            alignItems="center"
            justifyContent="space-between"
            direction={belowMd ? 'column' : 'row'}
            gap={belowMd ? 2 : 8}
            color="white"
          >
            <Box>
              <Typography
                fontSize={belowMd ? '30px' : '50px'}
                fontWeight={600}
                style={{ whiteSpace: 'pre-line' }}
                textAlign={belowMd ? 'center' : 'left'}
              >
                {'Your 48-Hour\nFree Trial\nHas Begun!\n'}
              </Typography>

              <Typography
                fontSize={belowMd ? '16px' : '20px'}
                textAlign={belowMd ? 'center' : 'left'}
              >
                You now have 48 hours to explore our platform and experience
                exclusive learning tools to boost your success.
              </Typography>
            </Box>
            <img
              src={`${process.env.PUBLIC_URL}/images/productValue/trial-begin.png`}
              alt="header"
            />
          </Stack>
          <Button {...buttonProps} onClick={handleOnClick}>
            Start Exploring
          </Button>
        </Stack>
      </Box>
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/productValue/elipse.png`}
        alt="footercorner"
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100px',
          height: '100px',
        }}
      />
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/productValue/union.png`}
        alt="headercorner"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '160px',
          height: '160px',
        }}
      />
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          color: 'white',
          top: 10,
          right: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

export default PremiumTrialStartModal;
